<template>
  <GameShell />
</template>

<script>
import GameShell from './components/GameShell.vue'

export default {
  name: 'App',
  components: { GameShell },
}
</script>

<style>
* {
  box-sizing: border-box;
}

body {
  margin: 0;
  background: #020617;
}

#app {
  margin: 0;
}
</style>